import React from "react";
import {
  MeetingDetailOuter,
  MeetingInfo,
  InfoValue,
  InfoLabel,
  InfoValueDate,
  IconLabelContainer,
  PendingDatesContainer,
  PendingDatesBtn,
} from "./style";
import Icon from "../../../../../../common/Icon";
import moment from "moment-timezone";

const MeetingDetails = ({ item, isTeam, unixStampToDate }) => {
  const renderDate = (date) => {
    const splitDate = unixStampToDate(date)?.split(" at ");
    return splitDate ? splitDate[0] : null;
  };
  const renderTime = (date) => {
    const splitDate = unixStampToDate(date)?.split(" at ");
    return splitDate ? splitDate[1] : null;
  };

  //

  const userTimeZone = moment.tz.guess();

  const convertUnixToUserTimeZone = (unixTimestamp) => {
    const date = moment
      .unix(unixTimestamp)
      .tz(userTimeZone)
      .format("dddd, MMMM D, YYYY");
    const time = moment.unix(unixTimestamp).tz(userTimeZone).format("h:mm A z");

    return { date, time };
  };

  const convertUnixToUserTimeZone2 = (unixTimestamp) => {
    return moment
      .unix(unixTimestamp)
      .tz(userTimeZone)
      .format("dddd, MMMM D, YYYY [at] h:mm A z");
  };

  return (
    <MeetingDetailOuter>
      <MeetingInfo>
        <Icon type="interview-icon" size="15" color="#000" />
        <InfoLabel>Reason for meeting: </InfoLabel>
        <InfoValue>
          {item?.program?.programType === "TEAM"
            ? item?.reasonForMeeting
            : item?.meeting?.reasonForMeeting}
        </InfoValue>
      </MeetingInfo>
      {item?.meeting?.meetingScheduleDate !== null ? (
        <MeetingInfo>
          <Icon type="calander-icon" size="15" color="#000" />
          <InfoLabel>Date: </InfoLabel>
          <InfoValue>
            {item.program?.programType === "TEAM"
              ? convertUnixToUserTimeZone(item?.meetingScheduleDate)?.date
              : convertUnixToUserTimeZone(item?.meeting?.meetingScheduleDate)
                  ?.date}
          </InfoValue>
        </MeetingInfo>
      ) : (
        <MeetingInfo>
          <IconLabelContainer>
            <Icon type="calander-icon" size="15" color="#000" />
            <InfoLabel>Dates:</InfoLabel>
          </IconLabelContainer>
          <InfoValue style={{ marginTop: "6px", width: "100%" }}>
            {/* <InfoValueDate>
              {item?.meeting?.dates.map((date) => {
                console.log("Date:", date);
                
                return <InfoValue>{renderDate(date.split("-")[0])}</InfoValue>;
              })}
            </InfoValueDate> */}
            <PendingDatesContainer>
              {item?.meeting?.dates
                ?.sort((a, b) => {
                  const aStart = parseInt(a.split("-")[0], 10);
                  const bStart = parseInt(b.split("-")[0], 10);
                  return aStart - bStart;
                })
                ?.map((date, index) => {
                  return (
                    <PendingDatesBtn>
                      {convertUnixToUserTimeZone2(date?.split("-")[0])}
                    </PendingDatesBtn>
                  );
                })}
            </PendingDatesContainer>
          </InfoValue>
        </MeetingInfo>
      )}
      {item?.meeting?.meetingScheduleDate !== null && (
        <MeetingInfo>
          <Icon type="clock-icon" size="15" color="#000" />
          <InfoLabel>Time: </InfoLabel>
          <InfoValue>
            {/* {renderTime(
            item.program?.programType === "TEAM"
              ? item?.meetingScheduleDate
              : item?.meeting?.meetingScheduleDate
          )} */}
            {item.program?.programType === "TEAM"
              ? convertUnixToUserTimeZone(item?.meetingScheduleDate)?.time
              : convertUnixToUserTimeZone(item?.meeting?.meetingScheduleDate)
                  ?.time}
          </InfoValue>
        </MeetingInfo>
      )}
      <MeetingInfo>
        <Icon type="location-icon" size="15" color="#000" />
        <InfoLabel>Location: </InfoLabel>
        <InfoValue>
          {item.program?.programType === "TEAM"
            ? item?.location
            : item?.meeting?.location}
        </InfoValue>
      </MeetingInfo>
      {item?.meeting?.meetingLink ? (
        <MeetingInfo>
          {" "}
          <Icon type="link-icon" size="15" color="#000" />
          <InfoLabel>Meeting Link:</InfoLabel>{" "}
          <InfoValue>{item?.meeting?.meetingLink}</InfoValue>
        </MeetingInfo>
      ) : null}
      <MeetingInfo>
        {" "}
        <Icon type="comments-icon" size="15" color="#000" />
        <InfoLabel>Additional Comments: </InfoLabel>
      </MeetingInfo>
      <MeetingInfo>
        {" "}
        <InfoValue>
          {item.program?.programType === "TEAM"
            ? item.additionalInfo
            : item?.meeting?.additionalInfo}
        </InfoValue>
      </MeetingInfo>
    </MeetingDetailOuter>
  );
};

export default MeetingDetails;
